/* eslint-disable no-shadow */
import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import moment from "moment";
import { editSettleAmount, settleAmount } from "../../../services/settlementService";
import { Button } from "../../../shared/widgets";
import SettlementFormValidator from "./operatorSettlement/SettlementFormValidator";
import { SettlementForm } from "./SettlementForm";

import { MessageType } from "../../../Constant";

class SettlementModal extends Component {
  constructor(props) {
    super(props);
    const { rowData, data } = this.props;
    this.state = {
      settlementDetailError: {},
      form: {},
      date: rowData?.ledgerDate ? rowData?.ledgerDate : null,
      restrictSettlement: false,
      paymentType: rowData?.type ? rowData?.type : "Paid",
      netDueAmount: rowData?.netDue ? rowData?.netDue : data?.finalNetDue || 0,
      settleAmount: rowData?.operatorPaymentAmount ? rowData?.operatorPaymentAmount : 0,
      transactionId: rowData?.transactionId ? rowData?.transactionId : "",
    };
  }

  handleDone = () => {
    const errorObj = this.updateFormErrorState();
    if (errorObj && Object.keys(errorObj).length === 0) {
      this.setState({ restrictSettlement: true });
      this.handleSettled();
    }
  };

  handleSettled = () => {
    const {
      rowData, data, currentDueVehicles, vehicleDetails,
    } = this.props;
    // eslint-disable-next-line no-shadow
    const {
      date,
      paymentType,
      settleAmount: settleAmountState,
      transactionId: transactionIdState,
    } = this.state;
    if (rowData?.itemType?.toLowerCase() === "operatorpayment") {
      const settlementDetails = {
        paymentDate: moment(
          `${moment(date).format("YYYY/MM/DD").toString()
          } ${
            new Date().toLocaleTimeString()}`,
        ).format("YYYY/MM/DD HH:mm").toString(),
        paymentType,
        paymentAmount: !Number.isNaN(Math.abs(settleAmountState)) && settleAmountState !== ""
          ? Math.abs(settleAmountState)
          : 0,
        operatorPaymentId: rowData?.operatorPaymentId,
        ...(transactionIdState && { transactionId: transactionIdState }),
      };
      this.OnEditSettleAmount(settlementDetails);
    } else {
      const settlementDetails = {
        paymentDate: moment(date).format("YYYY/MM/DD HH:mm").toString(),
        paymentType,
        netDueAmount: +data.netDueAmount,
        cardDueAmount: +data.cardDueAmount,
        lastPendingBalance: +data.lastPendingBalance,
        balanceLoaded: +data.balanceLoaded,
        walletUsage: +data.walletUsage,
        operatorDueAmount: +data.operatorDueAmount,
        ...(transactionIdState && { transactionId: transactionIdState }),
        settlementCalculationFields: data.settlementCalculationFields,
        vehicles: currentDueVehicles || [],
        settleAmount: !Number.isNaN(Math.abs(settleAmountState)) && settleAmountState !== ""
          ? Math.abs(settleAmountState)
          : 0,
        ...vehicleDetails,
      };
      this.OnSettleAmount(settlementDetails);
    }
  };

  /**
   * validates Settlement form data
   * @param target
   */

  updateFormErrorState = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const formState = SettlementFormValidator(this.state);
    this.setState({
      settlementDetailError: formState,
    });
    return formState;
  };

  handleChange = (input, type, objProp) => (value) => {
    switch (type) {
      case "event":
        this.setState(
          {
            [input]: objProp
              // eslint-disable-next-line max-len
              // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
              ? { ...this.state[input], [objProp]: value.target.value }
              : value.target.value,
          },
          () => {
            this.updateFormErrorState();
          },
        );
        break;
      case "value":
        this.setState({ [input]: value }, () => {
          this.updateFormErrorState();
        });
        break;
      default:
        break;
    }
  };

  OnSettleAmount(settlementDetails) {
    const { messageCallBack, processingData, setTokenExpired } = this.props;
    settleAmount(settlementDetails)
      .then(() => {
        messageCallBack(MessageType.SUCCESS, "Settled Successfully");
        processingData("close");
      })
      .catch((err) => {
        if (err.message.includes("Invalid token")) {
          setTokenExpired(true);
        } else {
          messageCallBack(MessageType.ERROR, err.message ? err.message : "Error occurred ");
        }
      });
  }

  OnEditSettleAmount(settlementDetails) {
    const { messageCallBack, processingData, setTokenExpired } = this.props;
    editSettleAmount(settlementDetails)
      .then(() => {
        messageCallBack(MessageType.SUCCESS, "Settled Successfully");
        processingData("close");
      })
      .catch((e) => {
        if (e.message.includes("Invalid token")) {
          setTokenExpired(true);
        } else {
          messageCallBack(MessageType.ERROR, e.message ? e.message : "Error occurred ");
        }
      });
  }

  render() {
    const { showModal, messageCallBack, processingData } = this.props;
    const { netDueAmount, date, settleAmount: settleAmountState } = this.state;
    return (
      <Dialog
        onClose={() => messageCallBack(null, null)}
        aria-labelledby="customized-dialog-title"
        open={showModal}
        className="settlementDialogWrapper"
      >
        <DialogTitle id="customized-dialog-title" onClose={() => messageCallBack(null, null)}>
          <div className="modalHeaderWrapper">
            <div className="dialogTitleText">Settle Amount</div>
            <div
              role="button"
              className="closeIcon"
              onClick={() => messageCallBack(null, null)}
              onKeyDown={() => {
              // key pressed
              }}
              tabIndex="0"
              aria-label="close"
            >
              <CloseIcon />
            </div>
          </div>
        </DialogTitle>
        <div className="dialogSubTitle">
          {"Net Amount: "}
          {netDueAmount}
        </div>
        <DialogContent>

          <div>
            <SettlementForm values={this.state} handleChange={this.handleChange} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button classname="backBtnContainer" onClick={() => messageCallBack(null, null)} buttonText="Cancel" />
          <Button
            // disable={this.state.form.invalid || this.state.restrictSettlement}
            disable={!(date && settleAmountState)}
            onClick={() => {
              this.handleDone();
              messageCallBack(null, null);
              processingData("start");
            }}
            buttonText="Settle"
          />
        </DialogActions>
      </Dialog>
    );
  }
}

SettlementModal.defaultProps = {
  showModal: false,
  vehicleDetails: {},
  messageCallBack: () => {
    // message callback
  },
};
SettlementModal.propTypes = {
  showModal: PropTypes.bool,
  messageCallBack: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  vehicleDetails: PropTypes.object,
};

export default SettlementModal;
